import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, LinearProgress } from '@mui/material'
import { ui } from '../../../utils/uiTokens'
import { crmApi } from '../../../features/crm/crmApi'
import { Card, Empty, PageHead, Pill, PrimaryButton, contentSx, pageSx } from '../shared/crmUi'
import { fmtDate, hm } from '../shared/format'
import { sellerStage } from '../shared/stages'
import IntakeInfo from '../shared/IntakeInfo'

// РОП: полная карточка ученика из «Барлық оқушылар»
const RopStudentPage = () => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const id = Number(useParams().id) || 0
    const { data: x, isFetching, isError } = crmApi.useGetIntakeQuery(id, { skip: !id })
    const back = (
        <Box
            component="button"
            type="button"
            onClick={() => navigate('/rop/students')}
            sx={{ border: 'none', background: 'transparent', color: ui.pink, fontWeight: 600, fontSize: '13px', cursor: 'pointer', padding: '0 0 10px', font: 'inherit' }}
        >
            ← {formatMessage({ id: 'crmAllStudents' })}
        </Box>
    )

    if (!x || x.id !== id)
        return (
            <Box sx={pageSx}>
                <Box sx={contentSx}>
                    {back}
                    {isFetching ? <LinearProgress /> : isError && <Empty />}
                </Box>
            </Box>
        )

    const st = sellerStage(formatMessage, x)
    const edited = x.editedAt ? ` · ${formatMessage({ id: 'crmLastEdit' }, { date: fmtDate(x.editedAt), time: hm(x.editedAt) })}` : ''

    return (
        <Box sx={pageSx}>
            <Box sx={contentSx}>
                {back}
                <PageHead
                    title={x.data.studentName}
                    sub={
                        <>
                            <Pill tone={st.tone} sx={{ marginRight: '8px' }}>
                                {st.text}
                            </Pill>
                            {formatMessage(
                                { id: 'crmRegisteredLine' },
                                { date: fmtDate(x.createdAt), time: hm(x.createdAt), name: x.sellerName || formatMessage({ id: 'crmRopSelf' }) },
                            )}
                            {edited}
                        </>
                    }
                    action={
                        x.status !== 'RETURNED' && (
                            <PrimaryButton onClick={() => navigate(`/rop/register?edit=${x.id}`)}>✎ {formatMessage({ id: 'crmEdit' })}</PrimaryButton>
                        )
                    }
                />
                <Card>
                    <IntakeInfo intake={x} installmentBox />
                </Card>
            </Box>
        </Box>
    )
}

export default RopStudentPage
